exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".setting-header[data-v-3eaa3f98]{background-color:#fbfbfb}.setting-body[data-v-3eaa3f98]{background-color:#fdfdfd}input[data-v-3eaa3f98],textarea[data-v-3eaa3f98]{border-style:solid}.token_password_toggle[data-v-3eaa3f98]{position:absolute;margin-top:-30px;right:20px}", ""]);

// exports
